export default "__VITE_ASSET__vg16MOIy__"